import { Header } from '@components/Header';
import { Helmet } from 'react-helmet-async';
import { Content } from './components/Content';

export const AdminDashboardPage = () => {
  return (
    <>
      <Helmet>
        <title>Dashboard - AutoScript Admin</title>
      </Helmet>
      <Header title={'Admin Dashboard'} />

      <Content />
    </>
  );
};
